/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import animateScrollTo from 'animated-scroll-to';

import {
  withRouter,
} from 'react-router-dom';

import {
  ExtendedFlex,
  ModalWithOverlay,
  ScrollToTopOnMount,
} from '../../../coreui';

import actions from '../../actions';

import PendingSummary from '../../components/PendingSummary';
import PendingInvestmentsTable from '../../components/PendingInvestmentsTable';
import PledgedInvestmentsTable from '../../components/PledgedInvestmentsTable';
import WaitlistInvestmentsTable from '../../components/WaitlistInvestmentsTable';
import WaitlistModal from '../../components/WaitlistModal';
import Watchlist from '../../components/Watchlist';

class PendingInvestmentsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.scrollToPending = this.scrollToPending.bind(this);

    // React 16.2 and earlier does not support ref forwarding. So, we simulate
    // it by giving the passed in ref function access to this.
    if (this.props.pendingRef) {
      this.props.pendingRef(this);
    }

    // Keep track of the ref for the pending components so that we can scroll
    // to it when requested.
    this.pendingInvestments = null;
    this.setPendingRef = (element) => {
      this.pendingInvestments = element;
    };

    this.waitlistTable = React.createRef();
  }

  componentWillUnmount() {
    if (this.props.modalVisible) {
      this.props.handleCloseModal();
    }
  }

  scrollToPending() {
    animateScrollTo(this.pendingInvestments, {
      passive: true,
    });
  }

  render() {
    const {
      pending,
      pledges,
      waitlist,
      watchlist,
      modalContent,
      modalVisible,
      handleCloseModal,
    } = this.props;

    return (
      <ExtendedFlex
        flexDirection="column"
        w={1}
        alignItems="center"
      >
        <ScrollToTopOnMount />
        <PendingSummary
          data={{
            pendingData: pending,
            pledgedData: pledges,
          }}
        />
        <div ref={this.setPendingRef} style={{ width: '100%' }} >
          <PendingInvestmentsTable
            scrollToMount={this.props.location.state &&
              this.props.location.state.pendingInvestmentsMessage}
            {...pending}
          />
        </div>
        <PledgedInvestmentsTable
          {...pledges}
        />
        {
          // We wrap our component in a plain div so that we can pass a ref to
          // to it. This allows the WaitList modal to have access to the node
          // so that we can scroll to it if the user clicks the appropriate
          // button.
        }
        <div ref={this.waitlistTable} style={{ width: '100%' }}>
          <WaitlistInvestmentsTable
            {...waitlist}
          />
        </div>
        <Watchlist
          {...watchlist}
        />
        <ModalWithOverlay
          isVisible={modalVisible}
          handleClick={handleCloseModal}
        >
          {
            modalContent === 'waitlist' &&
            <WaitlistModal
              handleClick={handleCloseModal}
              waitListRef={this.waitlistTable}
            />
          }
        </ModalWithOverlay>
      </ExtendedFlex>
    );
  }
}

// TODO: HERE. Implement flow
PendingInvestmentsContainer.propTypes = {
  pendingRef: PropTypes.func,
  location: PropTypes.object,
  pending: PropTypes.object,
  pledges: PropTypes.object,
  waitlist: PropTypes.object,
  watchlist: PropTypes.object,
  modalContent: PropTypes.string,
  modalVisible: PropTypes.bool,
  handleCloseModal: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    pending: state.dashboard.pendingData.pendingData,
    pledges: state.dashboard.pendingData.pledgedData,
    waitlist: state.dashboard.data.waitListData,
    watchlist: state.dashboard.data.watchListData,
    modalContent: state.dashboard.modalContent,
    modalVisible: state.dashboard.modalVisible,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleCloseModal: () => {
      dispatch(actions.pendingDashboardModalClose());
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PendingInvestmentsContainer),
);
